var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 679,
    viewBox: "0 0 222 679",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.00001L5 546",
    stroke: "url(#paint0_linear_2899_11373)",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 43L35 607",
    stroke: "url(#paint1_linear_2899_11373)",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94L67 558",
    stroke: "url(#paint2_linear_2899_11373)",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97 66L97 674",
    stroke: "url(#paint3_linear_2899_11373)",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127 193L127 546",
    stroke: "url(#paint4_linear_2899_11373)",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157 125L157 607",
    stroke: "url(#paint5_linear_2899_11373)",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187 79L187 645",
    stroke: "url(#paint6_linear_2899_11373)",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M217 345L217 546",
    stroke: "url(#paint7_linear_2899_11373)",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2899_11373",
    x1: 5.5,
    y1: 5,
    x2: 5.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#471D99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2899_11373",
    x1: 35.5,
    y1: 43,
    x2: 35.5,
    y2: 607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#471D99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2899_11373",
    x1: 67.5,
    y1: 94,
    x2: 67.5,
    y2: 558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#471D99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2899_11373",
    x1: 97.5,
    y1: 66,
    x2: 97.5,
    y2: 674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#471D99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2899_11373",
    x1: 127.5,
    y1: 193,
    x2: 127.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#471D99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2899_11373",
    x1: 157.5,
    y1: 125,
    x2: 157.5,
    y2: 607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#471D99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2899_11373",
    x1: 187.5,
    y1: 79,
    x2: 187.5,
    y2: 645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#471D99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2899_11373",
    x1: 217.5,
    y1: 345,
    x2: 217.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#471D99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutLine);
export default __webpack_public_path__ + "static/media/about_line.f4fee3158070873da7c5a925d1d5e926.svg";
export { ForwardRef as ReactComponent };